import { StoryReasonViewCall } from 'src/components/ui/ReasonView/stories/ReasonView.stories';

import CallsPicker from '../CallsPicker';

export default {
	title: 'Components/CallsPicker',
	component: CallsPicker,
	parameters: {},
	tags: ['autodocs'],
	args: {},
};

const call = {
	id: 1,
	plate: {
		topLines: [
			{ id: 1, text: '29.06.2023 09:03' },
			{ id: 2, text: '#6566755' },
		],
	},
	reason: {
		...StoryReasonViewCall.args,
		from: 'Леви Томас',
		to: 'Говнова Ольга',
		call: {
			...StoryReasonViewCall.args.call,
			duration: '03:22',
		},
	},
};

export const StoryCallsPickerPrimary = {
	name: 'Primary',
	args: {
		links: [
			{ id: 1, label: 'Необработанные 10', active: true },
			{ id: 2, label: 'Прикрепленные 2' },
			{ id: 3, label: 'Бесполезные 1' },
		],
		calls: new Array(5).fill(null).map((_, i) => {
			return { ...call, id: i };
		}),
		onChange: () => {},
	},
};

export const StoryCallsPickerNoCalls = {
	name: 'No Calls',
	args: { ...StoryCallsPickerPrimary.args, calls: undefined },
};

export const StoryCallsPickerNoLinks = {
	name: 'No Links',
	args: { ...StoryCallsPickerPrimary.args, links: undefined },
};

export { StoryCallsPickerForm as Form } from './Form';
